import bootstrapFunction from "~/bootstrapFunction";
import { registerDynamicModules } from "~/lib/centralStore/index";
import siteConfigData from "@/assets/site.config.json";

import "@/assets/styles.css";

registerDynamicModules(require.context("@/store", true, /.*\.js$/));

export default (context) =>
  bootstrapFunction({
    ...context,
    allRequireContext: {
      globalComponentsContext: require.context(
        "@/components/global",
        true,
        /.*\.vue$/
      ),
      widgetsContext: require.context("@/widgets", true, /.*\.vue$/),
      pluginsContext: require.context("@/plugins", true, /.*\.js$/),
      mockContext: require.context("@/assets/mock", true, /.*\.json$/),
      gqlContext: require.context("@/assets/gql", true, /.*\.js$/),
    },
    siteConfigData,
  });
